import type { RootState } from '@src/store/reduxstore';

// eslint-disable-next-line import/prefer-default-export
export const pagesWithoutAccessSelector = (state: RootState) =>
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //@ts-ignore
  state.adminHome.user.roleAccess?.pagesWithoutAccess || [];
